import dayjs, { Dayjs } from 'dayjs';

export const parseBackendDate = (dateStr: string | null | undefined): Dayjs | null => {
  if (!dateStr) return null;

  if (/^\d+$/.test(dateStr)) {
    return dayjs(Number(dateStr));
  }

  const d = dayjs(dateStr);
  return d.isValid() ? d : null;
};
